/* Little Joe - frontend interactions */
(function () {
  'use strict';

  // Mobile drawer
  const burger = document.querySelector('[data-lj-burger]');
  const drawer = document.querySelector('[data-lj-drawer]');
  const drawerClose = document.querySelector('[data-lj-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawer) drawer.addEventListener('click', (e) => {
    if (e.target === drawer) closeDrawer();
  });

  // Hero "ver packs" smooth scroll
  document.querySelectorAll('[data-lj-scroll]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = el.getAttribute('href');
      if (href && href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // Hero carousel dots (visual only - hooks for slider)
  const dots = document.querySelectorAll('[data-lj-hero-dot]');
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      dots.forEach((d) => d.setAttribute('aria-current', 'false'));
      dot.setAttribute('aria-current', 'true');
    });
  });

  // Free shipping progress bar
  const shippingBar = document.querySelector('[data-lj-shipping]');
  if (shippingBar) {
    const threshold = parseFloat(shippingBar.dataset.threshold || '0');
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const total = cart.total_price / 100;
        const remaining = Math.max(0, threshold - total);
        const labelEl = shippingBar.querySelector('[data-lj-shipping-remaining]');
        const reachedEl = shippingBar.querySelector('[data-lj-shipping-reached]');
        if (remaining > 0) {
          if (labelEl) labelEl.textContent = remaining.toFixed(2);
          if (reachedEl) reachedEl.hidden = true;
        } else {
          shippingBar.querySelector('[data-lj-shipping-pending]')?.setAttribute('hidden', '');
          if (reachedEl) reachedEl.hidden = false;
        }
      })
      .catch(() => {});
  }
})();
